module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "main-sidebar"
  }, [_c('section', {
    staticClass: "sidebar"
  }, [(_vm.$config.brand !== 'jkos') ? _c('ul', {
    staticClass: "sidebar-menu"
  }, [(_vm.getRoleType != 50) ? _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            主頁\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.goto
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            新後台管理系統\n          ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        設定\n      ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/accountTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-unlock-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            帳號管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/platformTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            平台管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/brandTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            品牌管理\n          ")])])], 1) : (_vm.getRoleType === 10 && _vm.sBrandId) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/' + _vm.sBrandId
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            店家管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/mealTagTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            餐點種類管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/announcement"
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            訊息公告\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'TradeSetting'
      }
    }
  }, [_c('img', {
    staticClass: "m-r-5",
    attrs: {
      "src": require("../assets/icon/cash-register.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            金流設定\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        訂單\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/orderTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            線上訂單列表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/onSiteOrderTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            線下訂單列表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType != 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/orderExceptionTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            例外訂單\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/blackListTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-frown-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            黑名單\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ratingTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-half-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            評價管理\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menuQuerystringView"
    }
  }, [_c('i', {
    staticClass: "fa fa-star-half-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            追蹤碼\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30 || _vm.getRoleType === 10) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        會員\n      ")]) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/memberTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            會員管理\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/shopperMoneyTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            會員消費管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    _vm.getRoleType !== 50
  ) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        菜單\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.$route.params.brand_id && !_vm.sStoreId && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/menuDetailTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-coffee"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [(_vm.getRoleType === 10) ? _c('router-link', {
    attrs: {
      "to": ("/brand/" + _vm.sBrandId + "/ajust/menu")
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            配料庫\n          ")])]) : _c('router-link', {
    attrs: {
      "to": '/brandMenu/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            配料庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [(_vm.getRoleType === 10) ? _c('router-link', {
    attrs: {
      "to": ("/brand/" + _vm.sBrandId + "/build/menu")
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單建置\n          ")])]) : _c('router-link', {
    attrs: {
      "to": '/brandMenuTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單建置\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productImage/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            圖片庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productSetting/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-certificate"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            別名 / 描述 / 警語\n          ")])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/cupDiscountTable/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('img', {
    staticClass: "m-r-5",
    staticStyle: {
      "width": "18px",
      "height": "18px"
    },
    attrs: {
      "src": require("../assets/icon/i_reusable_cup.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n              自備飲料杯管理\n            ")])])])], 1) : _vm._e(), _vm._v(" "), (
    (_vm.$route.params.brand_id || _vm.sStoreId) &&
    _vm.getRoleType !== 50
  ) ? _c('li', [(_vm.getRoleType === 10) ? _c('router-link', {
    attrs: {
      "to": ("/brand/" + _vm.sBrandId + "/schedule/menu")
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單排程\n          ")])]) : _c('router-link', {
    attrs: {
      "to": '/brandScheduleTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單排程\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        即時控管\n      ")]), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/printerTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            出單機管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/disItemTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            停賣管理\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/disItemScheduleTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            時段停賣管理\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/limitedItemScheduleTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-university"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            門市限時限量\n          ")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mqttTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-plug"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            連線管理\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        活動\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/discountTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            現折活動管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        對帳\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cashAccountTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            對帳記錄表\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/venderTradeTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            廠商對帳記錄表\n          ")])])], 1), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cashAccountErrorTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            對帳錯誤紀錄表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/cashAccountSearch"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            查詢交易資訊\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        統計報表\n      ")]) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/weekChartDash"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            週報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99 || _vm.getRoleType === 30) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/chartDash"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            月報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType === 99) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/marketingChart"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            行銷報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), ([99, 30, 10].includes(_vm.getRoleType)) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/operatingChart"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            營運報表\n          ")])])], 1) : _vm._e(), _vm._v(" "), ([99].includes(_vm.getRoleType)) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/systemUsage"
    }
  }, [_c('i', {
    staticClass: "fa fa-pie-chart"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            系統使用率報表\n          ")])])], 1) : _vm._e()]) : _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("\n        設定\n      ")]), _vm._v(" "), (_vm.getRoleType !== 10) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/brandTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            品牌管理\n          ")])])], 1) : (_vm.getRoleType === 10 && _vm.sBrandId) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/' + _vm.sBrandId
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            店家管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.getRoleType !== 50) ? _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        菜單\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.$route.params.brand_id && !_vm.sStoreId && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": "/menuDetailTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-coffee"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單管理\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/brandMenu/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-square"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            配料庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/brandMenuTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單建置\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productImage/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            圖片庫\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/storeTable/productSetting/' + _vm.brandIdForStore + (_vm.sStoreId && _vm.storeList.length === 1 ? '/' + _vm.sStoreId : '')
    }
  }, [_c('i', {
    staticClass: "fa fa-certificate"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            別名/描述/警語\n          ")])])], 1) : _vm._e(), _vm._v(" "), ((_vm.$route.params.brand_id || _vm.sStoreId) && _vm.getRoleType !== 50) ? _c('li', [_c('router-link', {
    attrs: {
      "to": '/brandScheduleTable/' + _vm.brandId
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            菜單排程\n          ")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "header"
  }, [_vm._v("\n        即時控管\n      ")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/disItemTable"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            停賣管理\n          ")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "https://nidin.shop/resource",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('i', {
    staticClass: "fa fa-cube"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("\n            你訂資源中心\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e5c6260"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 2389
// module chunks = 1